import React, { useState, useEffect } from 'react';
import {
  Col,
  Divider,
  FlexboxGrid,
  Grid,
  IconButton,
  Loader,
  Modal,
  Row,
  SelectPicker,
  Stack,
  Table
} from 'rsuite';
import { Panel, Placeholder } from 'rsuite';
import { Link, useLocation } from 'react-router-dom';
import { Icon, Width } from '@rsuite/icons';
import ArrowLeftIcon from '@rsuite/icons/ArrowLeft';
import ArrowRightIcon from '@rsuite/icons/ArrowRight';
import ReactImageMagnify from 'react-image-magnify';
import ArrowDownIcon from '@rsuite/icons/ArrowDown';
import ArrowUpIcon from '@rsuite/icons/ArrowUp';
import globalIP from '@/GlobelIP';
import viewImage from '../../../images/img2.jpg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import useLabel from '@/clientWeb/hook/Label';
import ugr from '@/UGRoute';
import useUser from '../../../components/UseUser';
// import './HomePages/home.css';
const cmToInch = value => (value / 2.54).toFixed(2);
const inchToCm = value => (value * 2.54).toFixed(2);
const { Column, HeaderCell, Cell } = Table;

// const convertDimensions = (data, selectedUnit) => {
//   const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

//   return data.map(item => {
//     let convertedItem = {
//       ...item,
//       Length: (item.Length || 0) * conversionFactor,
//       Width: (item.Width || 0) * conversionFactor,
//       Height: (item.Height || 0) * conversionFactor,
//       SizeUnit: selectedUnit,
//     };

//     // If the selected unit is cm, round to one decimal place
//     if (selectedUnit === 'cm') {
//       convertedItem.Length = parseFloat(convertedItem.Length.toFixed(1));
//       convertedItem.Width = parseFloat(convertedItem.Width.toFixed(1));
//       convertedItem.Height = parseFloat(convertedItem.Height.toFixed(1));
//     }

//     // If the selected unit is inch, round to the nearest whole number
//     if (selectedUnit === 'inch') {
//       convertedItem.Length = Math.round(convertedItem.Length);
//       convertedItem.Width = Math.round(convertedItem.Width);
//       convertedItem.Height = Math.round(convertedItem.Height);
//     }
//     console.log('Converted data :', convertedItem)
//     return convertedItem;
//   });
// };

const convertDimensions = (data, selectedUnit) => {
  const conversionFactor = selectedUnit === 'inch' ? 0.393701 : 2.54;

  return data.map(item => {
    // Skip conversion if the SizeUnit matches the selectedUnit
    if (item.SizeUnit === selectedUnit) {
      console.log('Unchanged data:', item);
      return item;
    }

    // Convert dimensions if SizeUnit does not match the selectedUnit
    let convertedItem = {
      ...item,
      Length: (item.Length || 0) * conversionFactor,
      Width: (item.Width || 0) * conversionFactor,
      Height: (item.Height || 0) * conversionFactor,
      SizeUnit: selectedUnit
    };

    console.log('Converted data:', convertedItem);
    return convertedItem;
  });
};

const ProductViewDetails = () => {
  const { user } = useUser();
  const size = [
    { label: 'CM', value: 'cm' },
    { label: 'Inch', value: 'inch' }
  ];
  const ip = globalIP;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id') || '';
  const variantId = searchParams.get('variantId') || '';
  const vid = searchParams.get('val') || 0;
  const [data123, setData123] = useState([]);
  const [mainid, setMainId] = useState('');
  const [productCode, setProductCode] = useState([]);
  const [data123Var, setData123Var] = useState([]);
  const [imageList, setImageList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { attributesName } = useLabel();
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let url = `${ip}/api/products?populate=*&filters[id][$eq]=${id}`;
    if (vid == 0) {
      url = `${ip}/api/variant-products?populate=*&filters[id][$eq]=${id}`;
    }
    const response = await fetch(url);
    const json = await response.json();
    // setSelectedUnit(json.data[0].attributes.SizeUnit)
    setData123(json.data);
    if (json.data[0].attributes.SetStatus === 'Set') {
      setSelectedUnit(json.data[0].attributes.SetSizes[0].SizeUnit);
      setData11(json.data[0].attributes.SetSizes);
    } else {
      setSelectedUnit(json.data[0].attributes.SizeUnit);
      const data = [
        {
          Length: json.data[0].attributes.Length,
          Width: json.data[0].attributes.Width,
          Height: json.data[0].attributes.Height,
          SizeUnit: json.data[0].attributes.SizeUnit
        }
      ];
      setData11(data);
    }
    setMainId(id);
    const extractedImageList = json.data
      .filter(item => item.attributes.MultipleImage && item.attributes.MultipleImage.data)
      .map(item => item.attributes.MultipleImage.data.map(image => image.attributes.url))
      .flat();
    const coverImage = json.data.map(item => item.attributes.CoverImage.data.attributes.url);
    extractedImageList.unshift(coverImage);
    const prefixed_list = extractedImageList.map(file => ip + file);
    setImageList(prefixed_list);
    setProductCode(json.data.map(item => item.attributes.ProductCode));
    setIsLoading(false);
  };
  useEffect(() => {
    if (variantId) {
      fetchData1();
    }
  }, [variantId]);
  const fetchData1 = async () => {
    const response = await fetch(
      `${ip}/api/variant-products?populate=*&filters[Variant_Id][$eq]=${variantId}&filters[id][$ne]=${id}`
    );
    const response1 = await fetch(
      `${ip}/api/products?populate=*&filters[ProductCode][$eq]=${variantId}&filters[id][$ne]=${id}`
    );
    const json = await response.json();
    const json1 = await response1.json();
    const alldata = [...json.data, ...json1.data];
    setData123Var(alldata);
  };
  // const defaultImageIndex = 0;
  // const [selectedImageIndex, setSelectedImageIndex] = useState(defaultImageIndex);

  // const handleNextImage = item => {
  //   setSelectedImageIndex(prevIndex => (prevIndex + 1) % imageList.length);
  // };

  // const handlePrevImage = item => {
  //   setSelectedImageIndex(prevIndex => (prevIndex - 1 + imageList.length) % imageList.length);
  // };

  // useEffect(() => {
  //   console.log('imgindex : ' + selectedImageIndex);
  //   setSelectedImagePath({
  //     url: data123[0]?.attributes?.MultipleImage?.data[selectedImageIndex]?.attributes?.url,
  //     id: data123[0]?.id,
  //     default: true
  //   });
  // }, [selectedImageIndex]);

  // useEffect(() => {
  //   const item = data123[0];  // Assuming you want the first item in the array

  //   if (item?.attributes?.CoverImage?.data?.attributes?.url) {
  //     setSelectedImagePath({
  //       url: item?.attributes?.CoverImage?.data?.attributes?.url,
  //       id: item.id,
  //       default: true
  //     });
  //   }
  // }, [data123]);

  const [selectedImageIndex, setSelectedImageIndex] = useState({});

  const getAllImages = item => {
    const cover = item?.attributes?.CoverImage?.data?.attributes?.url || '';

    const uniqueSortedMultipleImages = [...(item?.attributes?.MultipleImage?.data || [])]
      .filter(img => img?.attributes?.url?.trim())
      .filter(
        (img, index, self) => index === self.findIndex(i => i.attributes.url === img.attributes.url)
      )
      .sort((a, b) =>
        a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase())
      )
      .map(img => img.attributes.url);

    return [cover, ...uniqueSortedMultipleImages];
  };

  const handleNextImage = item => {
    const images = getAllImages(item);
    const currentIndex = selectedImageIndex[item.id] || 0;
    const nextIndex = (currentIndex + 1) % images.length;

    setSelectedImageIndex(prev => ({
      ...prev,
      [item.id]: nextIndex
    }));

    setSelectedImagePath({
      url: images[nextIndex],
      id: item.id,
      default: nextIndex === 0
    });
  };

  const handlePrevImage = item => {
    const images = getAllImages(item);
    const currentIndex = selectedImageIndex[item.id] || 0;
    const prevIndex = (currentIndex - 1 + images.length) % images.length;

    setSelectedImageIndex(prev => ({
      ...prev,
      [item.id]: prevIndex
    }));

    setSelectedImagePath({
      url: images[prevIndex],
      id: item.id,
      default: prevIndex === 0
    });
  };

  useEffect(() => {
    const item = data123[0]; // Assuming you want the first item in the array

    if (!item) {
      console.error('Item is undefined');
      return;
    }

    if (selectedImageIndex === 0) {
      console.log('imgindex : ' + selectedImageIndex);
      // When selected index is 0, set the CoverImage
      const coverImageUrl = item?.attributes?.CoverImage?.data?.attributes?.url;
      if (coverImageUrl) {
        setSelectedImagePath({
          url: coverImageUrl,
          id: item.id,
          default: true
        });
      } else {
        console.error('Cover image not found');
      }
    } else {
      console.log('imgindex11 : ' + selectedImageIndex);
      // Otherwise, set the corresponding MultipleImage
      const imageIndex = selectedImageIndex - 1; // Subtract 1 because CoverImage is index 0
      const selectedImage = item?.attributes?.MultipleImage?.data?.[imageIndex];
      if (selectedImage && selectedImage?.attributes?.url) {
        setSelectedImagePath({
          url: selectedImage?.attributes?.url,
          id: item.id,
          default: true
        });
      } else {
        console.error('Multiple image not found at index', imageIndex);
      }
    }
  }, [selectedImageIndex, data123]);

  const [isDivVisible, setDivVisible] = useState(true);
  const toggleDiv = () => {
    setDivVisible(!isDivVisible);
  };

  const [sizeUnit, setSizeUnit] = useState();

  // const handleSizeChange = newSizeUnit => {
  //   setSizeUnit(newSizeUnit);
  // };

  // const convertDimensions = (length, width, height, unit) => {
  //   let convertedDimensions = `${length}x${width}x${height}`;
  //   let finalUnit = unit;

  //   if (unit === 'inch' && sizeUnit === 'cm') {
  //     convertedDimensions = `${inchToCm(length)}x${inchToCm(width)}x${inchToCm(height)}`;
  //     finalUnit = 'cm';
  //   } else if (unit === 'cm' && sizeUnit === 'inch') {
  //     convertedDimensions = `${cmToInch(length)}x${cmToInch(width)}x${cmToInch(height)}`;
  //     finalUnit = 'inch';
  //   }

  //   return { dimensions: convertedDimensions, unit: finalUnit };
  // };
  // const convertDimensions = (dimensions, unit, sizeUnit) => {
  //   let convertedDimensions = dimensions;
  //   let finalUnit = unit;

  //   if (unit === 'inch' && sizeUnit === 'cm') {
  //     convertedDimensions = dimensions.map(dim => ({
  //       Length: inchToCm(dim.Length),
  //       Width: inchToCm(dim.Width),
  //       Height: inchToCm(dim.Height),
  //     }));
  //     finalUnit = 'cm';
  //   } else if (unit === 'cm' && sizeUnit === 'inch') {
  //     convertedDimensions = dimensions.map(dim => ({
  //       Length: cmToInch(dim.Length),
  //       Width: cmToInch(dim.Width),
  //       Height: cmToInch(dim.Height),
  //     }));
  //     finalUnit = 'inch';
  //   }

  //   return { dimensions: convertedDimensions, unit: finalUnit };
  // };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handleTimeUpdate = e => {
    setCurrentTime(e.target.currentTime);
    setDuration(e.target.duration);
  };

  const handleSeek = e => {
    const time = e.target.value;
    setCurrentTime(time);
    const video = document.getElementById('videoPlayer');
    video.currentTime = time;
  };

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [finShow, setFinShow] = useState(false);
  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setFinShow(json.data[0].attributes.setFinish);
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  const [loading, setLoading] = useState(true);
  const handleloader = () => {
    setLoading(false);
  };

  const handleImageSelect = imagePath => {
    setHoveredImagePath(imagePath);
  };
  const [hoveredImagePath, setHoveredImagePath] = useState('');
  const [selectedImagePath, setSelectedImagePath] = useState({ url: '', id: null, default: true });
  const [calcwidth, setcalcwidth] = useState(1200);
  useEffect(() => {
    if (selectedImagePath.url) {
      // Create a new Image object
      const img = new Image();
      img.src = globalIP + selectedImagePath.url;

      // Once the image is loaded, calculate the width
      img.onload = () => {
        const newCalcWidth = (800 * img.width) / img.height;
        setcalcwidth(newCalcWidth);
        console.log('calcwidth', newCalcWidth);
      };
    }
    console.log('selectedImagePath', selectedImagePath);
  }, [selectedImagePath.url]);

  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const unitOptions = [
    { label: 'Inch', value: 'inch' },
    { label: 'CM', value: 'cm' }
  ];

  const [data11, setData11] = useState(null);
  const [data12, setData12] = useState(null);

  const [selectedUnit, setSelectedUnit] = useState('');

  const handleSizeChange = value => {
    setSelectedUnit(value);
    const convertedData = convertDimensions(data11, value);
    setData11(convertedData);
  };

  return (
    <div style={{ margin: '80px 10px' }}>
      <Grid fluid>
        {data123.map(item => {
          return (
            <Row>
              <Col lg={12} xs={24} style={{ textAlign: '-webkit-center' }}>
                <div style={{}} className="arrow arrow-left" onClick={() => handlePrevImage(item)}>
                  <Icon as={ArrowLeftIcon} />
                </div>
                <div className="imgp1" style={{ height: '400px', display: 'flex' }}>
                  <ReactImageMagnify
                    {...{
                      className: 'magnify',
                      imageStyle: { objectFit: 'contain' },
                      smallImage: {
                        alt: 'Product Image',
                        height: 400,
                        width: 400,
                        className: 'magnify',
                        // isFluidWidth: true,

                        src:
                          selectedImagePath.url && selectedImagePath.id == item.id
                            ? `${globalIP}${selectedImagePath.url}`
                            : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`
                      },
                      largeImage: {
                        src:
                          selectedImagePath.url && selectedImagePath.id == item.id
                            ? `${globalIP}${selectedImagePath.url}`
                            : `${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`,
                        height: 800,
                        width: calcwidth
                      },
                      isHintEnabled: true,
                      enlargedImagePosition: 'beside',
                      enlargedImageContainerDimensions: { width: 800, height: 600 }
                    }}
                  />
                </div>

                <div
                  style={{}}
                  className="arrow1 arrow-right"
                  onClick={() => handleNextImage(item)}
                >
                  <Icon as={ArrowRightIcon} />
                </div>

                {!item.attributes.MultipleImage.data && (
                  <div style={{ padding: '15px 50px' }}>
                    <Swiper
                      spaceBetween={20}
                      navigation={true}
                      slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                      pagination={{ clickable: true }}
                      modules={[Navigation]}
                      className="nestedSwiper"
                    >
                      {data123.some(item => item.attributes?.threeDview?.data?.attributes?.url) && (
                        <SwiperSlide style={{ height: 'auto' }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignContent: 'center',
                              width: '100% !important',
                              height: '100% !important'
                            }}
                          >
                            <img
                              src={viewImage}
                              style={{
                                height: '52px !important',
                                width: '52px !important',
                                cursor: 'pointer',
                                margin: 'auto',
                                objectFit: 'contain'
                              }}
                              onClick={handleOpen}
                            />
                          </div>
                        </SwiperSlide>
                      )}
                      <SwiperSlide>
                        <div
                          style={{
                            height: '80px',
                            borderRadius: '5px',
                            overflow: 'hidden'
                          }}
                        >
                          <img
                            src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            onClick={() =>
                              setSelectedImagePath({
                                url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                id: item.id,
                                default: true
                              })
                            }
                          />
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                )}
                {item.attributes.MultipleImage.data && (
                  <div style={{ padding: '15px 10px' }}>
                    <Swiper
                      spaceBetween={20}
                      navigation={true}
                      slidesPerView={window.innerWidth >= 746 ? 6 : 3}
                      pagination={{ clickable: true }}
                      modules={[Navigation]}
                      className="nestedSwiper"
                      style={{
                        width: window.innerWidth >= 746 ? '45vw' : '80vw'
                      }}
                    >
                      <SwiperSlide>
                        <div
                          style={{
                            height: '80px',
                            borderRadius: '5px',
                            overflow: 'hidden'
                          }}
                          className={
                            selectedImagePath.url ==
                              item?.attributes?.CoverImage?.data?.attributes?.url &&
                              selectedImagePath.id == item.id
                              ? 'image-product-select image-product-select-active'
                              : null
                          }
                        >
                          <img
                            src={`${globalIP}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                            alt=""
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            onClick={() =>
                              setSelectedImagePath({
                                url: item?.attributes?.CoverImage?.data?.attributes?.url,
                                id: item.id,
                                default: true
                              })
                            }
                          />
                        </div>
                      </SwiperSlide>
                      {data123.some(item => item.attributes?.threeDview?.data?.attributes?.url) && (
                        <SwiperSlide style={{ height: 'auto' }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignContent: 'center',
                              width: '100%',
                              height: '100%'
                            }}
                          >
                            <img
                              src={viewImage}
                              style={{
                                height: '80px',
                                cursor: 'pointer',
                                margin: 'auto',
                                objectFit: 'contain'
                              }}
                              onClick={handleOpen}
                            />
                          </div>
                        </SwiperSlide>
                      )}
                      {[...item.attributes.MultipleImage.data]
                        .sort((a, b) =>
                          a.attributes.name
                            .toLowerCase()
                            .localeCompare(b.attributes.name.toLowerCase())
                        )
                        .map(multiImage => (
                          <SwiperSlide key={multiImage.id}>
                            <div
                              style={{
                                height: '80px',
                                borderRadius: '5px',
                                overflow: 'hidden'
                              }}
                              className={
                                selectedImagePath.url === multiImage.attributes.url &&
                                  selectedImagePath.id === item.id
                                  ? 'image-product-select image-product-select-active'
                                  : null
                              }
                            >
                              <img
                                src={`${globalIP}${multiImage.attributes.url}`}
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                onClick={() =>
                                  setSelectedImagePath({
                                    url: multiImage.attributes.url,
                                    id: item.id,
                                    default: true
                                  })
                                }
                              />
                            </div>
                          </SwiperSlide>
                        ))}
                    </Swiper>
                  </div>
                )}
              </Col>

              <Col lg={12} xs={24}>
                <div style={{ padding: '10px 20px' }} className="slide-product-table">
                  <div className="slide-product-name roboto-medium">
                    {item.attributes.ProductName}
                  </div>
                  <div className="slide-product-details ">
                    <span className="roboto-medium">Description</span>
                    <p className="roboto-regular">{item.attributes.Description}</p>
                  </div>
                  {/* {item.attributes.SetStatus !== 'Set' && 
                    (
                    )
                  } */}
                  <Divider style={{ margin: '10px 0' }} />

                  {!sizeshow && (
                    <div>
                      {item.attributes.SetStatus !== 'Set' && (
                        // const {Length ,Width ,Height ,SizeUnit} = item.attributes,
                        <div>
                          <span
                            className="roboto-medium"
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <p style={{ marginLeft: '0rem', color: '#005c80' }}>LxWxH</p>
                            <SelectPicker
                              data={size}
                              searchable={false}
                              defaultValue={item.attributes.SizeUnit}
                              onChange={handleSizeChange}
                              size="sm"
                              cleanable={false}
                            />
                          </span>
                          <p>
                            {data11[0].Length.toFixed(2)} x {data11[0].Width.toFixed(2)} x{' '}
                            {data11[0].Height.toFixed(2)} {selectedUnit}
                          </p>
                        </div>
                      )}
                      <p className="roboto-regular">
                        {(() => {
                          const isSet = item.attributes.SetStatus === 'Set';

                          if (isSet) {
                            const { dimensions, unit } = convertDimensions(
                              item.attributes.SetSizes.map(({ Length, Width, Height }) => ({
                                Length,
                                Width,
                                Height
                              })),
                              item.attributes.SizeUnit
                              // sizeUnit
                            );

                            return (
                              <Table
                                height={180}
                                width={550}
                                data={data11}
                                onRowClick={rowData => {
                                  // console.log(rowData);
                                }}
                                bordered
                                cellBordered
                                wordWrap="break-word"
                                rowHeight={20}
                              >
                                <Column width={120} align="center" fixed>
                                  <HeaderCell><b>Part Desc.</b></HeaderCell>
                                  <Cell dataKey="Description" />
                                </Column>

                                <Column width={250} align="center">
                                  <HeaderCell style={{ marginTop: '-4px' }}>
                                    <b>LxWxH</b>
                                    <SelectPicker
                                      data={unitOptions}
                                      searchable={false}
                                      value={selectedUnit}
                                      onChange={handleSizeChange}
                                      size="sm"
                                      cleanable={false}
                                      style={{ marginLeft: '8px' }}
                                    />
                                  </HeaderCell>
                                  <Cell>
                                    {rowData =>
                                      `${rowData.Length.toFixed(2) || 0}x${rowData.Width.toFixed(2) || 0
                                      }x${rowData.Height.toFixed(2) || 0} ${rowData.SizeUnit}`
                                    }
                                  </Cell>
                                </Column>

                                <Column width={100}>
                                  <HeaderCell><b>{label[0]?.attributes.NetWgt}</b></HeaderCell>
                                  <Cell dataKey="NetWt" />
                                </Column>

                                <Column width={100}>
                                  <HeaderCell><b>{label[0]?.attributes.color}</b></HeaderCell>
                                  <Cell dataKey="ColorName" />
                                </Column>
                                {finShow && (
                                  <>
                                    <Column width={125}>
                                      <HeaderCell><b>Finish</b></HeaderCell>
                                      <Cell dataKey="FinishName" />
                                    </Column>

                                    <Column width={125}>
                                      <HeaderCell><b>Mat. Name</b></HeaderCell>
                                      <Cell dataKey="MatName" />
                                    </Column>
                                  </>
                                )}
                              </Table>
                            );
                          }
                        })()}
                      </p>
                    </div>
                  )}
                  <div className="slide-product-details ">
                    <span className="roboto-medium">Product Details</span>
                  </div>
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">Set Status</div>
                    <div>{item.attributes.SetStatus}</div>
                  </div>
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">{attributesName?.AliasCode || 'Alias Code'}</div>
                    <div>{item.attributes.ProductId}</div>
                  </div>
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">{attributesName?.Category || 'Category'}</div>
                    <div>{item.attributes.CategoryName}</div>
                  </div>
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">
                      {attributesName?.ProductType || 'Product Type'}
                    </div>
                    <div>{item.attributes.ProductTypeName}</div>
                  </div>
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">{attributesName?.finish || 'Finish'}</div>
                    <div>{item.attributes.FinishName}</div>
                  </div>
                  {item.attributes.SetStatus !== 'Set' && (
                    <div className="slide-product-Alias ">
                      <div className="roboto-medium">{attributesName?.color || 'Color'}</div>
                      <div>{item.attributes.ColorName}</div>
                    </div>
                  )}
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">{`Product ${attributesName?.cbm}` || 'CBM'}</div>
                    <div>{item.attributes.cbm}</div>
                  </div>
                  {sizeshow && (
                    <div className="slide-product-Alias ">
                      <div className="roboto-medium">
                        {attributesName?.SizeRange || 'Free Size'}
                      </div>
                      <div>{item.attributes.SizeRange}</div>
                    </div>
                  )}
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">
                      {attributesName?.GrossWgt || 'Gross Weight (Kg)'}
                    </div>
                    <div>{item.attributes.GrossWeight}</div>
                  </div>
                  {item && item.attributes.SetStatus !== 'Set' && (
                    <div className="slide-product-Alias ">
                      <div className="roboto-medium">{attributesName?.NetWgt || 'Net Weight (Kg)'}</div>
                      <div>{item.attributes.NetWeight}</div>
                    </div>
                  )}
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">{attributesName?.HSN || 'HSN'}</div>
                    <div>{item.attributes.HSNCode}</div>
                  </div>
                  <div className="slide-product-Alias ">
                    <div className="roboto-medium">{attributesName?.MOQ || 'MOQ'}</div>
                    <div>{item.attributes.MOQ}</div>
                  </div>
                </div>
                <Panel
                  header="Other Details"
                  collapsible
                  bordered
                  defaultExpanded
                  style={{ width: '75%', margin: '5px' }}
                >
                  {(user.CATShwPrice === true || user.Category === 'Admin') && (
                    <div className="slide-product-Alias ">
                      <div className="roboto-medium">
                        {attributesName?.SalePrice || 'Sale Price'}
                      </div>
                      <div>
                        {item.attributes.SellingPrice} {item.attributes.SellingPriceCurrency}
                      </div>
                    </div>
                  )}
                  {item.attributes.BuyerName && (
                    <div className="slide-product-Alias">
                      <div className="roboto-medium">
                        {attributesName?.BuyerName || 'BuyerName'}
                      </div>
                      <div>{item.attributes.BuyerName}</div>
                    </div>
                  )}

                  {item.attributes.BuyerSku && (
                    <div className="slide-product-Alias">
                      <div className="roboto-medium">{attributesName?.BuyerSku || 'BuyerSku'}</div>
                      <div>{item.attributes.BuyerSku}</div>
                    </div>
                  )}
                </Panel>
                <Panel
                  header="Material Details"
                  collapsible
                  bordered
                  style={{ width: '75%', margin: '5px' }}
                >
                  <div style={{ overflowX: 'auto' }}>
                    <Table
                      data={item.attributes.ProductionDetail}
                      autoHeight
                      bordered
                      cellBordered
                      style={{ minWidth: '620px', marginTop: '10px' }}
                    >
                      <Column width={90} align="left" fullText>
                        <HeaderCell>
                          <b>Material</b>
                        </HeaderCell>
                        <Cell dataKey="MaterialNm" />
                      </Column>

                      <Column width={90} align="left" fullText>
                        <HeaderCell>
                          <b>Component</b>
                        </HeaderCell>
                        <Cell dataKey="Component" />
                      </Column>
                      <Column width={160} align="left" fullText>
                        <HeaderCell>
                          <b>L x W x H x D Unit</b>
                        </HeaderCell>
                        <Cell>
                          {rowData =>
                            `${rowData.Length ?? 0} x ${rowData.Width ?? 0} x ${rowData.Height ?? 0} x ${rowData.Depth ?? 0} ${rowData.Unit ?? ""}`
                          }
                        </Cell>
                      </Column>
                      <Column width={70} align="left" fullText>
                        <HeaderCell>
                          <b>Net Wt</b>
                        </HeaderCell>
                        <Cell dataKey="MatNetWeight" />
                      </Column>
                      <Column width={100} align="left" fullText>
                        <HeaderCell>
                          <b>Finish</b>
                        </HeaderCell>
                        <Cell dataKey="MaterialFinishNm" />
                      </Column>
                      <Column width={100} align="left" fullText>
                        <HeaderCell>
                          <b>Weight/Qty</b>
                        </HeaderCell>
                        <Cell dataKey="Qty" />
                      </Column>
                    </Table>
                  </div>
                </Panel>
                <Panel
                  header="Packing Details"
                  collapsible
                  bordered
                  style={{ width: '75%', margin: '5px' }}
                >
                  {/* <FlexboxGrid justify="start">
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Carton Type</b>:<p>{item.attributes.Packaging[0]?.CartonType || ''}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Dim</b>:
                        <p>
                          {item.attributes.Packaging[0]?.Carton_Length}x
                          {item.attributes.Packaging[0]?.Carton_Width}x
                          {item.attributes.Packaging[0]?.Carton_Thick}{' '}
                          {item.attributes.Packaging[0]?.Carton_Unit}
                        </p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Carton CBM</b>:<p>{item.attributes.Packaging[0]?.Carton_CBM}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Carton PCS</b>:<p>{item.attributes.Packaging[0]?.Carton_PCS}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Carton/PCS</b>:<p>{item.attributes.Packaging[0]?.Carton_CBMperpc}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Gross Wt.</b>:<p>{item.attributes.Packaging[0]?.Carton_GrsWt}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Total CBM</b>:<p>{item.attributes.Total_CBM}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>Total CFT</b>:<p>{item.attributes.Total_CFT}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>20 FT</b>:<p>{item.attributes.TwentyFT != "null" ? item.attributes.TwentyFT : 0}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>40 FT</b>:<p>{item.attributes.FortyFT != "null" ? item.attributes.FortyFT : 0}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                      <Stack spacing={5}>
                        <b>40 HQ</b>:<p>{item.attributes.FortyHQ != "null" ? item.attributes.FortyHQ : 0}</p>
                      </Stack>
                    </FlexboxGrid.Item>
                  </FlexboxGrid> */}
                  <Table
                    height={200}
                    data={item.attributes.Packaging}
                    style={{ marginTop: '20px' }}
                    bordered
                  >
                    <Table.Column width={90} align="center" fixed>
                      <Table.HeaderCell>Carton Type</Table.HeaderCell>
                      <Table.Cell dataKey="CartonType" />
                    </Table.Column>

                    <Table.Column width={150}>
                      <Table.HeaderCell>Dimensions</Table.HeaderCell>
                      <Table.Cell>
                        {rowData => {
                          // Using rowData to display the dimensions directly
                          return `${rowData?.Carton_Length || '0'} x ${rowData?.Carton_Width || '0'
                            } x ${rowData?.Carton_Thick || '0'} ${rowData?.Carton_Unit || ''}`;
                        }}
                      </Table.Cell>
                    </Table.Column>

                    <Table.Column width={80}>
                      <Table.HeaderCell>Box Area</Table.HeaderCell>
                      <Table.Cell dataKey="Carton_CBMperpc" />
                    </Table.Column>

                    <Table.Column width={50}>
                      <Table.HeaderCell>PCS</Table.HeaderCell>
                      <Table.Cell dataKey="Carton_PCS" />
                    </Table.Column>

                    <Table.Column width={90}>
                      <Table.HeaderCell>CBM</Table.HeaderCell>
                      <Table.Cell dataKey="Carton_CBM" />
                    </Table.Column>

                    <Table.Column width={80}>
                      <Table.HeaderCell>Gross Wt.</Table.HeaderCell>
                      <Table.Cell dataKey="Carton_GrsWt" />
                    </Table.Column>
                  </Table>
                  <Stack
                    justifyContent="space-between"
                    style={{ paddingInline: '1.5rem', marginTop: '1rem' }}
                  >
                    <Stack>
                      <Stack direction="column" spacing={5}>
                        <b>Total CBM</b>
                        <p>{item.attributes.Total_CBM}</p>
                      </Stack>
                    </Stack>
                    <Stack>
                      <Stack direction="column" spacing={5}>
                        <b>Total CFT</b>
                        <p>{item.attributes.Total_CFT}</p>
                      </Stack>
                    </Stack>
                    <Stack>
                      <Stack direction="column" spacing={5}>
                        <b>20 FT</b>
                        <p>{item.attributes.TwentyFT != 'null' ? item.attributes.TwentyFT : 0}</p>
                      </Stack>
                    </Stack>
                    <Stack>
                      <Stack direction="column" spacing={5}>
                        <b>40 FT</b>
                        <p>{item.attributes.FortyFT != 'null' ? item.attributes.FortyFT : 0}</p>
                      </Stack>
                    </Stack>
                    <Stack>
                      <Stack direction="column" spacing={5}>
                        <b>40 HQ</b>
                        <p>{item.attributes.FortyHQ != 'null' ? item.attributes.FortyHQ : 0}</p>
                      </Stack>
                    </Stack>
                  </Stack>
                </Panel>
              </Col>
            </Row>
          );
        })}
      </Grid>
      {data123Var.length > 0 ? (
        <Panel bordered className="main">
          <h5>Variants Products</h5>

          <FlexboxGrid>
            {data123Var.map(item => (
              <FlexboxGrid.Item as={Col} colspan={24} md={6}>
                {/* onClick={() => handleOpen('full', item.attributes.ProductId)} */}
                <Link
                  to={{
                    pathname: `/${ugr}/productView`,
                    search: `?id=${item.id}&variantId=${item.attributes.Variant_Id}&val=${item.attributes.Variant ? 1 : 0
                      }`
                  }}
                  className="link"
                  target="_blank"
                >
                  <div className="col-md-12">
                    <Panel
                      className="box"
                      bordered
                      bodyFill
                      style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}
                    >
                      <img
                        src={`${ip}${item?.attributes?.CoverImage?.data?.attributes?.url}`}
                        alt="Image"
                        className="imgp"
                        style={{ objectFit: 'contain', margin: "auto" }}
                      />
                      <div className="overlay">Quick View</div>
                      <Panel>
                        <b>Product : {item.attributes.ProductName} </b>
                        <p>
                          {label[0]?.attributes.AliasCode} : {item.attributes.ProductId}
                        </p>
                      </Panel>
                    </Panel>
                  </div>
                </Link>
              </FlexboxGrid.Item>
            ))}
          </FlexboxGrid>
        </Panel>
      ) : null}
      {open && (
        <Modal size="sm" open={open} onClose={handleClose} backdrop="static">
          <Modal.Header>
            <Modal.Title>360&deg; View</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {loading && (
              <>
                <Loader
                  content="Loading"
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                  }}
                />
              </>
            )}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <video
                src={`${ip}${data123.map(
                  item => item.attributes?.threeDview?.data?.attributes?.url
                )}`}
                height={500}
                width={500}
                id="videoPlayer"
                controls={false}
                autoPlay
                onTimeUpdate={handleTimeUpdate}
                onLoadedData={handleloader}
                loop
              />
              <input
                type="range"
                min={0}
                max={duration}
                value={currentTime}
                onChange={handleSeek}
                style={{
                  width: '50%',
                  position: 'fixed',
                  top: '15%',
                  left: '25%',
                  height: '100%',
                  opacity: '-0.9'
                }}
              />
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default ProductViewDetails;
